import { Amplify, API, Auth, graphqlOperation } from "aws-amplify";
import awsconfig from "../../aws-exports";
import { getRolByUser } from "../../graphql/myQueries";

Amplify.configure(awsconfig);

async function signIn(email = "", password = "") {
  try {
    return await Auth.signIn(email, password);
  } catch (error) {
    return null;
  }
}

async function signOut() {
  try {
    return await Auth.signOut();
  } catch (error) {
    return null;
  }
}

async function getUserRole(accountID = "") {
  try {
    const response = await API.graphql(
      graphqlOperation(getRolByUser, { id: accountID })
    );
    return response.data.getAccount.role;
  } catch (error) {
    return "";
  }
}

async function getIdUserService() {
  Auth.currentAuthenticatedUser()
    .then((user) => {
      //console.log("Usuario [getIdUserService] ", user?.username);
      return user?.username;
    })
    .catch((err) => {
      console.log(err);
      return "userServiceDesktop";
    });
}

export { signIn, signOut, getUserRole, getIdUserService };
